import { styled } from "@mui/material/styles";
import { ResponsiveContainer } from "recharts";

export const StyledResponsiveContainer = styled(ResponsiveContainer)(
  ({ theme }) => ({
    marginLeft: theme.spacing(6)
  })
);
